
<VueShowdown
	:markdown="content"
	:flavor="flavor"
	:options="options"
	:extensions="extensions"
	:vue-template="vueTemplate"
	class="flow-markdown"
/>
